function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
import Icon from '../Icon.js';
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M.8 6.8a6 6 0 1 0 12 0 6 6 0 0 0-12 0v0ZM15.2 15.2l-4.157-4.157",
    stroke: "var(--icon-color)",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
var IconSearch = function IconSearch(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    icon: SvgSearch
  }, props));
};
export default IconSearch;